import theme from '@styles/theme';
export default {
  styledLabel: (color = theme.rawColors.neutralBlack) => ({
    fontFamily: theme.fonts.uniformMedium,
    fontWeight: theme.fontWeights.medium,
    display: 'inline',
    textTransform: 'uppercase',
    fontSize: '8px',
    letterSpacing: '0.8px',
    color,
    ml: '3px',
    lineHeight: '140%'
  })
};